// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".simple_navbar[data-v-4d43422a]{height:50px;background:#fafafa;padding:0 24px;display:flex;align-items:center;position:fixed;top:0;left:0;right:0;z-index:1000}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
